import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { Module } from "types/generated";
import useEnableModule from "shared/Module/useEnableModule";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AccessResult } from "utils/access";

type EnableButtonProps = {
  moduleId: Module["id"];
  refetchQueries?: string[];
  callback?: () => void;
  canEnable: AccessResult;
};

const EnableButton = ({ moduleId, callback, refetchQueries, canEnable }: EnableButtonProps) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [enableModule, { loading }] = useEnableModule({
    refetchQueries,
  });

  const handleClick = () => {
    enableModule({ id: moduleId }, (data) => {
      if (data?.moduleEnable) {
        reportSuccess({ message: "Module successfully enabled" });
        callback?.();
      }
    });
  };

  if (!canEnable.result && !canEnable.message) {
    return null;
  }

  return (
    <DropdownMenuItem
      onAction={handleClick}
      loading={loading}
      isDisabled={loading || !canEnable.result}
      tooltip={canEnable.message}
      tooltipWidthMode="maxWidthSm"
    >
      Enable
    </DropdownMenuItem>
  );
};

export default EnableButton;
